import React from "react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../../components/ui/table";
import { formatCurrency } from "../utils";
import { OpenChargesSession } from "../../../types/CustomerInterface";
interface OpenChargesSessionProps{
  charges?:OpenChargesSession[]
}

export const OpenChargesSection: React.FC<OpenChargesSessionProps> = ({charges }) => {

  const formatDatein = (d?: string) => {
    if (!d) return "N/A";
  
    const date = new Date(d);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const year = date.getFullYear();
  
    return `${day}/${month}/${year}`;
  };

  const totalAmount = charges?.reduce((sum, charge) => sum + (charge?.amount ?? 0), 0) ?? 0;

  return (
    <section className="mb-6">
      <div className="flex items-center gap-3 mb-6">
        {/* <div className="w-8 h-8 bg-green-600 rounded-full flex items-center justify-center">
          <span className="text-white font-bold text-sm">4</span>
        </div> */}
        <h3 className="text-xl font-bold text-[#9e7926]">Open Charges</h3>
      </div>

      {/* <div className="mb-4 p-4 bg-[#f2efe4] rounded-lg border border-[#9e7926]"> */}
      <div className="mb-4 p-4 bg-white rounded-lg border shadow-sm overflow-hidden">
        <div className="flex justify-between items-center">
          {/* <span className="font-semibold text-[#9e7926]">Total Charges Amount:</span> */}
          <span className="font-semibold text-gray-900">Total Charges Amount:</span>
          <span className="text-lg font-bold text-[#9e7926]">{formatCurrency(totalAmount)}</span>
        </div>
      </div>

      <div className="bg-white rounded-lg border shadow-sm overflow-hidden">
        <Table className="break-inside-avoid-page">
          <TableHeader>
            <TableRow className="bg-gray-50">
              <TableHead className="font-semibold text-gray-900">Charge Holder</TableHead>
              <TableHead className="font-semibold text-gray-900">Date</TableHead>
              <TableHead className="text-right font-semibold text-gray-900">Amount</TableHead>
              <TableHead className="font-semibold text-gray-900">Type</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {charges?.map((charge, index) => (
              <TableRow key={index} className="hover:bg-gray-50">
                <TableCell className="font-medium">{charge.holder_name}</TableCell>
                <TableCell>{formatDatein(charge.date)}</TableCell>
                <TableCell className="text-right font-semibold">{formatCurrency(charge.amount)}</TableCell>
                <TableCell>
                  <span className="bg-green-100 text-green-800 text-xs px-2 py-1 rounded-full font-medium">
                    {charge.type}
                  </span>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </section>
  );
};
